export default "__VITE_ASSET__8ca16168__"